import React from "react";
import { BookOpen } from "lucide-react";
import PdfFirstPageThumbnail from "./PdfFirstPageThumbnail";

function daysLeft(dateStr) {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const d = new Date(dateStr);
  d.setHours(0, 0, 0, 0);

  const diff = Math.round((d - today) / (1000 * 60 * 60 * 24));

  if (diff < 0) return "Expired";
  if (diff === 0) return "Last day";
  if (diff === 1) return "1 day left";
  return `${diff} days left`;
}


export default function CatalogSection({ catalogs, onOpenCatalog }) {
  // Use only items containing a latestCatalogue
  const validCatalogs = catalogs.filter((c) => c.latestCatalogue);
   const formatDate = (dateStr) => {
  const [y, m, d] = dateStr.split("-");
  return new Date(y, m - 1, d).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "long",
  });
};

  return (
    <section className="bg-white/95 border border-slate-200/80 rounded-2xl shadow-xl p-5 space-y-3 flex flex-col">
      <header className="flex items-center justify-between gap-3">
        <h3 className="text-sm font-semibold">In-store offer catalogs</h3>

        <div className="flex items-center gap-2 text-[0.72rem] text-slate-500">
          <span>Flip through latest UAE booklets</span>
          <span className="px-2 py-0.5 rounded-full bg-slate-100 text-slate-700">
            {validCatalogs.length}
          </span>
        </div>
      </header>

      {validCatalogs.length > 0 ? (
        <div className="grid gap-10 2xl:grid-cols-2 grid-cols-1 self-center">
          {validCatalogs.map((catalogObj) => {
            const c = catalogObj.latestCatalogue; // shortcut

            return (
              <button
                key={c.id}
                type="button"
                onClick={() => onOpenCatalog(catalogObj)} // pass full object
                className="flex flex-col text-left border border-slate-200/80 rounded-2xl p-1.5 bg-white hover:shadow-lg transition w-[260px]"
              >
                {/* Thumbnail */}
                <div className="relative h-[326px]  rounded-xl overflow-hidden">
                  {/* <img
                    src={c.catalogueImageUrl}
                    alt={c.catalogueName}
                    className="w-full h-full object-cover"
                  /> */}
                  <div className="flex justify-center">
                  <PdfFirstPageThumbnail
                    pdfUrl={`https://api.gulf.deals/store-offer/pdf?url=${(
                      c.catalogueImageUrl
                    )}`}
                  />
                  </div>


                  <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-slate-900/5 to-transparent flex items-end justify-end p-1.5 opacity-0 hover:opacity-100 transition text-white">
                    <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-white/20 backdrop-blur">
                      <BookOpen className="w-3.5 h-3.5" />
                    </span>
                  </div>
                </div>

                {/* Catalog Info */}
                <div className="mt-2 space-y-0.5">
                  <p className="text-[0.8rem] font-semibold">
                    {c.storeName || catalogObj.storeName}
                  </p>

                  <p className="text-[0.78rem] line-clamp-2 text-slate-800">
                    {c.catalogueName}
                  </p>

                  <p className="text-[0.72rem] text-slate-500">
                    Ends on {formatDate(c.validTo)} · {daysLeft(c.validTo)}
                  </p>
                </div>
              </button>
            );
          })}
        </div>
      ) : (
        <p className="text-[0.74rem] text-slate-600">
          No catalogs available yet.
        </p>
      )}
    </section>
  );
}
